<template>
  <div>
    <div class="test-content">
      <ul>
        <JudgeLi v-for="(pep,index) in arr" :content="pep" :type="1" :key="index" v-on:listenToChildEvent="showMsg"></JudgeLi>
      </ul>
      <div class="numShow">
        <span class="progress-text">得分<span class="right-text">{{rightNum}}</span></span>
        <div class="progress-back">
          <div class="progress-font" :style="widthStyle"></div>
        </div>
      </div>
      <!-- <button class="default-btn end-btn" v-if="show" @click="saveCosKnowlegeAnswer" v-preventReClick>闯关结束</button> -->
      <div class="modal-box" v-if="modalshow">
        <div class="modal-content">
          <p class="modal-title">你已完成10题，可以选择继续或结束闯关</P>
          <p>接下来，请选择</p>
          <button class="default-btn submit-btn" @click="continueBack">继续做题，挑战自己</button>
          <button class="default-btn end-btn" @click="saveCosKnowlegeAnswer" v-preventReClick>闯关结束</button>
        </div>
      </div>
    </div>
    <div class="button-box" v-if="next">
      <button class="default-btn large-btn end-btn" @click="continueNext">知道了，继续</button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import JudgeLi from '../components/JudgeLi';
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  props: {
    id: Number
  },
  name: 'Competence',
  components:{
    'JudgeLi':JudgeLi
  },
  data () {
    return {
        next:false,
        arr:[
            {'num':1,'order':'1/60','title':'某种职业的要求包括：关心人的成长，乐于与他人分享自己的想法和信息；具备科研创新能力，愿意在不断的实践、反思与调整中获得进步；能敏锐地察觉他人的情绪和态度，以正面、积极的情绪带动周围的人。你认为这个职位是？','answer':['A.秘书','B.会计','C.教师','D.护士'],'rightAnswer':'C','show':true},
            {'num':2,'order':'2/60','title':'有种职业既要具备管理、法律等知识，又需要具备企业文化建设、战略管理、激励、绩效导向、员工关系管理等能力，请问是哪种职业？','answer':['A.人力资源总监','B.后勤','C.行政总监','D.记者'],'rightAnswer':'A','show':false},
            {'num':3,'order':'3/60','title':'假如你是一名银行柜员，你认为你需要具备以下几种能力？学习能力、工作速度与准确性、沟通与表达、吃苦耐劳和抗压能力、服务意识、诚实正直。','answer':['A.4种','B.5种','C.3种','D.全部都要具备'],'rightAnswer':'D','show':false},
            {'num':4,'order':'4/60','title':'三位面试官在讨论是否录用某个候选人，你认为他们讨论的职位是哪个？面试官A:小仁成绩还不错，财务管理、税务、法律方面的知识还是挺扎实的。面试官B:比较踏实，之前也做过财务分析，沟通方面感觉也没什么问题。面试官C:嗯，工作方法也比较清晰有条理。','answer':['A.销售专员','B.人力资源专员','C.行政专员','D.会计'],'rightAnswer':'D','show':false},
            {'num':5,'order':'5/60','title':'小仁用“影响力、共情、真诚、支配性、分析性思维、人际觉察力、关系构建、主动学习”来介绍某种职业的胜任力素质模型，你猜是哪种？','answer':['A.护士','B.心理咨询师','C.编导/导演','D.市场总监'],'rightAnswer':'B','show':false},
            {'num':6,'order':'6/60','title':'BOSS表扬小仁具有社会责任感，知识视野广阔，善于观察、沟通与表达能力强，文字功底强，善于创新，时间观念强，理性冷静，应变能力强。你认为小仁从事的是什么职业？','answer':['A.客服专员','B.项目执行','C.记者','D. 演员'],'rightAnswer':'C','show':false},
            {'num':7,'order':'7/60','title':'小能乐观、自信,有强烈的追求成功的欲望，为了获取成功，他愿意承担一定的风险和压力，他常常为自己设定有挑战性的目标，而且从不轻言放弃；他善于发现并满足客户的隐含需求，总是给人留下一种值得信任的印象。你认为小能具备的素质最符合以下哪个职位的要求？','answer':['A.销售','B.算法工程师','C.游戏开发','D.通信技术'],'rightAnswer':'A','show':false},
            {'num':8,'order':'8/60','title':'假如小仁具备“用户调研能力、需求获取能力、需求评估能力、需求撰写能力、行业分析能力、产品设计能力、沟通能力”等能力，你认为Ta从事的应该是哪一职业？','answer':['A.网络工程师','B.产品经理','C.数据分析师','D.保险销售'],'rightAnswer':'B','show':false},
            {'num':9,'order':'9/60','title':'小仁说小能具有开阔的行业视野、策略性思考能力、社会新潮敏感度、商业灵敏度、社会网络维护能力、开拓精神、互联网思维和新媒体运作能力，你说小能是以下哪种职业人员？','answer':['A.排版设计','B.经纪人','C.影视工作者','D.广告创意师'],'rightAnswer':'D','show':false},
            {'num':10,'order':'10/60','title':'小仁说Ta马上要晋升新的职位，压力有点大，因为该职位要求他能够带领团队，负责整个产品线。这就意味着，他一方面要能够合理分配工作任务、对员工给予专业指导，另一方面，要对用户需求、设计方案、产品开发、测试、试运行、验收等负责。你猜小仁晋升的新职位是哪个？','answer':['A.产品运营','B.总经理','C.产品经理','D.运营总监'],'rightAnswer':'C','show':false},
            {'num':11,'order':'11/60','title':'小达具备“系统思考能力、团队领导力、决策能力、沟通协调能力、行政事务处理能力、关注细节能力、应变能力”，你猜小达可能是以下哪种职业人员？','answer':['A.数据分析师','B.机械工程师','C.行政总监','D.律师'],'rightAnswer':'C','show':false},
            {'num':12,'order':'12/60','title':'小能说Ta小时候想从事一种具有“公司知识、管理知识、关注细节能力、行政事务处理能力、问题解决能力、沟通协调能力、文案管理与写作能力”的职业，请问是以下哪种职业？','answer':['A.行政秘书','B.质检员','C.客服经理','D.编辑'],'rightAnswer':'A','show':false},
            {'num':13,'order':'13/60','title':'小仁非常佩服同事小能：分析财务报表、建立财务预测模型、信息收集、数据分析都不在话下，对投资、金融知识了若指掌，他总是能对金融市场做出准确判断，制定合理投资策略，并能沉着应对市场中各种突变风险。小能不仅在专业上高瞻远瞩，对同事也从不吝分享经验。你认为小能的职位最可能是哪种？','answer':['A.证券交易员','B.人力资源专员','C.保险顾问','D.出纳'],'rightAnswer':'A','show':false},
            {'num':14,'order':'14/60','title':'小仁好学，有丰富的知识，如语言、人文史地、心理学、交通知识；他不满足现状，强烈渴求成功；他善于运用生动的语言与他人进行交流，能妥善处理组织内外各种关系。愿意帮助他人，有责任心，能果断、灵活地处理危机事件。你认为他具备哪个职位要求的素质？','answer':['A.历史研究员','B.心理咨询师','C.导游','D.教师'],'rightAnswer':'C','show':false},
            {'num':15,'order':'15/60','title':'有种岗位的胜任力需要包括“客户服务意识、技术操作能力、市场敏感性、数据分析能力、诚信意识、执行力、注重效率、沟通合作能力”，你猜可能是以下哪种？','answer':['A.电商运营','B.算法工程师','C.酒店服务员','D.数据分析师'],'rightAnswer':'A','show':false},
            {'num':16,'order':'16/60','title':'小达想应聘某个职位，该职位对从业人员的主要要求如下：（1）思维逻辑性较强，反应敏捷；（2）能自如地识别、理解、运用、生成语言，并能有效运用各种策略实现语言转换；（3）能快速适应语言环境、与周围环境保持良好沟通。你认为小达应聘的是哪个职位。','answer':['A.外贸专员','B.销售人员','C.翻译（口译）','D. 导游'],'rightAnswer':'C','show':false},
            {'num':17,'order':'17/60','title':'H公司来了一个新同事，该同事的岗位胜任力素质包括：具备秘书知识、公关关系知识、行政人事知识，文书书写知识、人际理解力、沟通力和亲和力等。你猜可能是以下哪种？','answer':['A.客服专员','B.秘书','C.后勤','D.咨询总监'],'rightAnswer':'B','show':false},
            {'num':18,'order':'18/60','title':'小仁的一天：早上来到公司的第一件事就是打开电脑刷新近期发布的招聘信息；接着，筛选收到的简历，到各部门与负责人沟通应聘者的情况，如果有合适人选，就开始电话邀约候选人参加面试。如果有同事离职，小任还要安排时间与该同事进行离职面谈。从小任的工作内容来看，你认为他最需要具备哪项能力？','answer':['A.文案撰写能力','B.沟通能力','C.领导力','D.想象力'],'rightAnswer':'B','show':false},
            {'num':19,'order':'19/60','title':'现在很多毕业生都会选择从事一种职业，该职业的胜任力包括：政治学习、意志品质、公关决策能力、职业品质、领导力、应对能力、综合技能、团队合作”，你猜可能是以下哪种职业？','answer':['A.经纪人','B.法律顾问','C.公务员','D.科研人员'],'rightAnswer':'C','show':false},
            {'num':20,'order':'20/60','title':'H公司最近想招聘一名具备以下能力的人员：（1）能够快速获取商品信息、市场价格和供应商信息；（2）能进行询价、比价、议价等商务谈判事务，对供应商的选择有准确判断力；（3）能灵活处理各类不符合预期的事件。你认为招聘的是什么职位呢？','answer':['A.物业顾问','B.规划设计师','C.采购专员','D.土建工程师'],'rightAnswer':'C','show':false},
            {'num':21,'order':'21/60','title':'用“企业文化、组织诊断、领导力、愿景建设能力、资源平衡能力、促进员工成长、沟通与影响力、战略思维能力”这些词来形容一个职业所必须具备的能力要求，你猜可能是以下哪种？','answer':['A.人力资源总监','B.招聘经理','C.绩效考核专员','D.薪酬福利专员'],'rightAnswer':'A','show':false},
            {'num':22,'order':'22/60','title':'小仁说有种职业需要具备“国际贸易知识、仓储运输知识、法律法规知识、安全管理知识、风险管理能力、组织协调能力、处理突发问题能力、团队合作能力”等，你猜小仁说的可能是以下哪种职业？','answer':['A.安检员','B.物流经理','C.订单管理','D.仓库管理'],'rightAnswer':'B','show':false},
            {'num':23,'order':'23/60','title':'小能精通财会及金融知识，在提高企业资本运作水平、预控企业财务风险方面非常有经验。他总是能快速把握工作要领，准确部署各项工作，积极利用各种资源达成目标。他善于沟通，能够平衡组织内外各种关系，也乐于协助其它部门或人员完成任务。你认为小能具备的素质最符合以下哪个职位的要求？','answer':['A.保险销售','B.金融研究员','C.理财顾问','D.财务经理'],'rightAnswer':'D','show':false},
            {'num':24,'order':'24/60','title':'有种专业的学生能力素质模型为：具备责任心、认真、学习能力、英语表达能力、交际能力、学习能力和应变能力等，还要掌握经济学、贸易规则和政策等知识。你猜可能是以下哪种专业？','answer':['A.翻译','B.英语教师','C.商务英语','D.公务员'],'rightAnswer':'C','show':false},
            {'num':25,'order':'25/60','title':'有种职业既要具备管理、法律等知识，还需要具备企业文化建设、战略管理、激励、绩效导向、员工关系管理等能力，请问是哪种职业？','answer':['A.人力资源总监','B.后勤','C.行政总监','D.记者'],'rightAnswer':'A','show':false},
            {'num':26,'order':'26/60','title':'某事业单位中有个岗位对人才的要求是：成就取向、服务意识、团队领导、沟通协调能力、冲突管理能力、问题解决能力、影响力、人际理解能力和灵活性。你猜这是什么岗位？','answer':['A.银行柜员','B.教师','C.行政管理','D.临床医生'],'rightAnswer':'C','show':false},
            {'num':27,'order':'27/60','title':'有种职业对人才的要求如下：（1）具有强烈的追求成功的动机，诚信、有责任心；（2）具备市场开拓与维护技能、供应链管理技能、外语技能和外贸知识；（3）具有优秀的学习、沟通、灵活变通和谈判能力；（4）有风险意识、专业意识和服务意识。你猜是什么职业？','answer':['A.置业顾问','B.外贸业务员','C.保险顾问','D.银行会计'],'rightAnswer':'B','show':false},
            {'num':28,'order':'28/60','title':'有种职业既要具备财务管理、财务会计、税务学、财务等专业知识，又要具备应变能力、自学能力、组织协调能力等，你猜是什么职业？','answer':['A.人力资源主管','B.会计','C.保险销售','D.会展策划'],'rightAnswer':'B','show':false},
            {'num':29,'order':'29/60','title':'某个企业招聘电子商务专业的人才，岗位要求是具备文字表达能力、沟通交流能力、用户研究能力、网页制作能力、资料收集能力、思考总结能力等，你猜是什么职业？','answer':['A.网络营销','B.软件开发工程师','C客服专员','D.网站程序员'],'rightAnswer':'A','show':false},
            {'num':30,'order':'30/60','title':'小能精通财会及金融知识，在提高企业资本运作水平、预控企业财务风险方面非常有经验。他总是能快速把握工作要领，准确部署各项工作，积极利用各种资源达成目标。他善于沟通，能够平衡组织内外各种关系，也乐于协助其它部门或人员完成任务。你认为小能具备的素质最符合以下哪个职位的要求？','answer':['A.保险销售','B.金融研究员','C.理财顾问','D.财务经理'],'rightAnswer':'D','show':false},
            {'num':31,'order':'31/60','title':'有种专业的学生需要具备的胜任力包括：思维能力、执行能力、理解能力、问题解决能力、协作能力，还要具备系统完善的计算机知识和英语知识。你猜可能是以下哪种专业？','answer':['A.计算机科学与技术','B.自动化','C.数字传媒艺术','D.商务英语'],'rightAnswer':'A','show':false},
            {'num':32,'order':'32/60','title':'哪类人才需要具备以下素质？具备丰富的人文史地、心理学、美学知识；运用所学知识帮助顾客，为顾客服务和创造价值；对工作相关的事物反应灵敏，如顾客反应、新闻、数字等；有健康的身体，良好的心理素质，充沛的精力；能妥善处理与顾客、上司、同事等组织内外关系。','answer':['A.旅游人才','B.书店店员','C.房地产策划专员','D.物业顾问'],'rightAnswer':'A','show':false},
            {'num':33,'order':'33/60','title':'有种专业的学生需要具备基本的软硬件开发能力、网络平台开发能力、利用SQL语言实现数据库的访问等专业能力，还需具备系统思维能力、问题解决能力、创新能力、英语阅读和交流能力等。你猜可能是以下哪种专业？','answer':['A.物联网工程','B.数据通信','C.电子商务','D.商务英语'],'rightAnswer':'A','show':false},
            {'num':34,'order':'34/60','title':'有种职业的胜任力由以下特质组成：关怀他人、人际理解、沟通能力、正向期待、自我调节、信息收集、服务意识、评估反思能力等。你猜可能是以下哪种职业？','answer':['A.会计','B.导游','C.客服专员','D.社会工作者'],'rightAnswer':'D','show':false},
            {'num':35,'order':'35/60','title':'小仁想应聘某个职位，该职位对从业人员的主要要求如下：（1）遵守职业伦理，具备药物和药学专业知识，能依据处方准确调配药物；（2）有服务意识，能与他人有效沟通，并能妥善处理各类人际冲突；（3）熟悉药品采购流程和库存管理方法，能适时采购缺失药品；（4）能依据经验，开展应用性研究。小仁想应聘的职位是？','answer':['A.育婴师','B.健身教练','C.药剂师','D.放射科医师'],'rightAnswer':'C','show':false},
            {'num':36,'order':'36/60','title':'有种岗位对人才的胜任能力要求为：具备基础专业知识和美学功底、创新力、构思能力、洞察力、想象力、信息获取能力、团队合作能力、情绪管理能力、责任心，具备建筑、园艺和室内设计等知识。你猜可能是以下哪种岗位？','answer':['A.土木工程师','B.美术教师','C.环境设计师','D.产品研发专员'],'rightAnswer':'C','show':false},
            {'num':37,'order':'37/60','title':'有种岗位的责任重大，要负责制定和实施集团公司总体战略和年度经营计划，要求具备领导能力、决策能力、沟通能力、影响力、计划能力、危机公关能力等多种能力。你猜可能是以下哪种岗位？','answer':['A.市场总监','B.行政总监','C.总裁','D.运营总监'],'rightAnswer':'C','show':false},
            {'num':38,'order':'38/60','title':'要求具备：有较强的市场感知能力和现场管理能力，能够敏锐的把握市场动态、市场方向，还需要沟通协调和组织能力。你猜这可能是描述哪种岗位？','answer':['A.市场经理','B.项目经理','C.行政总监','D.产品经理'],'rightAnswer':'A','show':false},
            {'num':39,'order':'39/60','title':'小H要寻找一份工作，该岗位要求应聘人员能够根据公司产品及市场行情拟定各种促销方案，并监督各种促销方案的实施和评估，还要具备良好的客户意识及业务拓展能力、学习能力、表达能力和说服力。你猜小H找的是什么岗位？','answer':['A.市场拓展经理','B.促销主管','C.市场策划主管','D.市场研究专员'],'rightAnswer':'B','show':false},
            {'num':40,'order':'40/60','title':'有种职位的工作内容包括根据市场需求制定各种公关关系策略和战术，善于客户资源的维护和沟通、管理，要求从业人员具备较强的市场感知能力、观察力、应变能力、人际交往和协调能力，还需要语言和文字表达能力。你猜这是哪个职位的胜任要求？','answer':['A.市场公关人员','B.法务专员','C.经纪人','D.运营专员'],'rightAnswer':'A','show':false},
            {'num':41,'order':'41/60','title':'某个岗位要求从业人员掌握法律法规知识、管理学知识、酒店知识、计算机知识，还需要具备积极主动意识、服务意识、责任感、语言表达能力、人际沟通能力、组织协调能力等多种能力。该岗位指的是？','answer':['A.酒店管理','B.宴会管理','C.宾客服务管理','D.酒店营销'],'rightAnswer':'A','show':false},
            {'num':42,'order':'42/60','title':'有种岗位要求从业者具备财税知识、金融知识、政策法规知识，还需要具备逻辑思维能力、数据分析能力、技术运用能力、决策能力、协作能力、人际交往能力、学习能力等。你猜可能是以下哪种岗位？','answer':['A.收银员','B.统计员','C.生产管理','D.审计'],'rightAnswer':'D','show':false},
            {'num':43,'order':'43/60','title':'用“临床基本能力、沟通能力、掌握与运用医学知识、团队合作能力、信息管理能力、自主学习能力、科研能力”来形容某岗位的胜任力要求。你猜可能是以下哪种岗位？','answer':['A.临床医生','B.医药代表','C.护理人员','D.药库主任'],'rightAnswer':'A','show':false},
            {'num':44,'order':'44/60','title':'某学者探讨了互联网某职位应该具备的胜任力模型,构建出人际技能、成就动机、专项服务能力、思维能力、沟通能力、客户管理能力、组织协调能力、压力调节能力的胜任力模型。该学者研究的哪个职位？','answer':['A.培训讲师','B.客户经理','C.行政管理','D.商务谈判'],'rightAnswer':'B','show':false},
            {'num':45,'order':'45/60','title':'某个岗位要求从业者要了解运动营养学、运动保健学、健康评估、饮食营养搭配等必备知识，还要具备教学能力、创新能力、营销能力和人际沟通能力。这个岗位是？','answer':['A.健身教练','B.康复理疗师','C.营养师','D.保健按摩师'],'rightAnswer':'A','show':false},
            {'num':46,'order':'46/60','title':'小仁很佩服某个职业，这个职业要求从业者要有坚定的政治立场、纪律意识、服务导向、洞察力、分析判断能力、逻辑思维能力、沟通协调能力、突发事件处置能力等胜任力素质。你觉得这是哪个职业？','answer':['A.社区工作者','B.保安','C.警察','D.物业人员'],'rightAnswer':'C','show':false},
            {'num':47,'order':'47/60','title':'小达毕业后想留在本校工作，为此他应聘了某个岗位，该岗位要求从业者具备专业及人力资源管理知识、领导经验、驱动力、学习能力、分析能力、影响力、沟通协调能力、培养他人能力、变革管理能力等。你觉得小达应聘的是哪个岗位？','answer':['A.图书管理员','B.辅导员','C.档案管理员','D.宿管人员'],'rightAnswer':'B','show':false},
            {'num':48,'order':'48/60','title':'大学生“村官”的能力素质包括执行能力、沟通能力、协调能力、公文处理能力、应变能力、适应能力、联系群众能力等能力，掌握农业知识、三农政策等知识，还要有廉洁奉公、服务农村的意识。上述描述是否正确？','answer':['正确','错误'],'rightAnswer':'1','show':false},
            {'num':49,'order':'49/60','title':'成为一个优秀的出版社编辑人员，需要有政治素养、策划能力、语言文字能力、沟通协调能力、判断能力、信息感知能力、审美能力。上述描述是否正确？','answer':['正确','错误'],'rightAnswer':'1','show':false},
            {'num':50,'order':'50/60','title':'某个职业要求从业者掌握护理学、管理学、人文学科相关理论知识和专科护理技能、急救技能、计算机操作应用技能、逻辑分析思维、服务导向、决策能力、问题解决能力。这里的“某个职业”指的是医生，不是护士。','answer':['正确','错误'],'rightAnswer':'0','show':false},
            {'num':51,'order':'51/60','title':'小仁说一个合格的注册会计师要具备：企业会计准则知识、审计相关业务知识、经济法律知识、信息技术知识、报告和研究能力、团队合作能力、逻辑思维能力、表达能力、适应变革能力、社会责任感、独立客观公正意识。针对小仁的描述，你认为ta说的是否正确？','answer':['正确','错误'],'rightAnswer':'1','show':false},
            {'num':52,'order':'52/60','title':'T公司的某个岗位要求从业者掌握计算机软件研发、维护等相关知识，熟悉各种开发语言，还要具备逻辑思维能力、问题分析能力、计划性、抗压能力、应变能力、团队合作能力等多种素质。小达说这个岗位是数据架构师，不是软件工程师。你认为小达的说法？','answer':['正确','错误'],'rightAnswer':'0','show':false},
            {'num':53,'order':'53/60','title':'有个岗位要求从业者掌握环境认知知识、法制知识、能源管理知识、成就导向、开拓创新、团队合作能力、规划能力、问题解决能力、决策能力等。小能说这个岗位不是能源管理师，是环境工程师。小能的说法是？','answer':['正确','错误'],'rightAnswer':'0','show':false},
            {'num':54,'order':'54/60','title':'Z银行的某个岗位的优秀职员具备抗压能力、创新能力、客户导向、信息搜集与分析能力、政策导向、目标导向、资源整合能力、风险防控意识、学习总结能力等多种素质。小达说这个岗位肯定是客户经理而不是风控专员。你认为小达的看法是？','answer':['正确','错误'],'rightAnswer':'1','show':false},
            {'num':55,'order':'55/60','title':'从事幼教工作，需要具备儿童观念、班级管理能力、角色监控能力、人际交往能力、自我反思能力、教学技能、教学策略知识、职业道德、责任感、细心耐心、亲切友善等素质。这句话是否正确？','answer':['正确','错误'],'rightAnswer':'1','show':false},
            {'num':56,'order':'56/60','title':'“普通话水平、朗诵能力、专业知识、语言表达能力、表现力与感染力、仪表举止、临场应变能力、团队合作能力”这些胜任力素质最有可能的是描述以下哪个职位？','answer':['A．教师','B．导演','C．主持人','D．演员'],'rightAnswer':'C','show':false},
            {'num':57,'order':'57/60','title':'某个岗位的人员应该具备以下专业能力，包括选题策划能力、个人感召力、节目创新能力、组织能力、应变能力、理解影响力，这个岗位最有可能是？','answer':['A．记者','B．导演','C．网络主播','D．主持人'],'rightAnswer':'B','show':false},
            {'num':58,'order':'58/60','title':'“设计伦理、人际理解、客户导向、专业性、沟通能力、积极主动、分析式思维、成本意识、创造力”这些素质项最有可能的是描述以下哪个职位？','answer':['A．设计师','B．导演','C．影视策划','D．活动策划'],'rightAnswer':'A','show':false},
            {'num':59,'order':'59/60','title':'小仁和小能在讨论某个岗位所要求的素质项，包括“学习能力、抗压能力、判断甄选能力、责任心、成就导向、关系建立能力、信息获取能力、人际洞察力、影响力”，他们最有可能的讨论的是以下哪个职位？','answer':['A．秘书','B．培训专员','C．绩效考核专员','D．猎头'],'rightAnswer':'C','show':false},
            {'num':60,'order':'60/60','title':'“复杂反应能力、注意力分配能力、学习能力、作业稳定性、情绪稳定、逻辑判断、应变能力、责任意识、执行能力、过硬的身体素质”这些素质项最有可能的是描述以下哪个职位？','answer':['A．驾驶员','B．列车乘务','C．货运代理','D．物流专员'],'rightAnswer':'A','show':false}
            ],
          data:'',   //已做题目的答案
          rightNum:0,  //答对题数
          rightScore:0,
          numShow:false, //控制答题进度的显示
          show:false, //控制闯关结束的显示
          modalshow:false, //控制15题模态框的显示
          widthStyle:{
            width:''
          },
          current:0,
          submitNum:0
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('生涯驿站-职业能力知多少');
  },
  methods:{
    saveCosKnowlegeAnswer(){
      if(this.submitNum==0){
        console.log(this.data);
        this.submitNum=1
        const id = this.id // eslint-disable-line no-unused-vars
        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded'},
          data:qs.stringify({
            submitdata: this.data,
            openId: this.shengyaUser.openid
          }),
          
          url:'/cob/saveCosKnowlegeAnswer.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let cosAnswer = response.data
            let shengyaUser = cosAnswer.data.user
            this.$bus.$emit('play-finish', shengyaUser)
          }
        })
        .catch((error)=>{
          console.log(error);
        })
      }
    },
    // 保存本题所选答案，如果答对切换到下一题，如果答错，显示闯关结束。
    showMsg(res,cur){
        const right_answer = this.arr[cur - 1].rightAnswer;
        this.current = cur
        // 保存每一题的答案
        this.data += cur + "$" + res
        if (cur < 60) {
          this.data += "}"
          if (res == right_answer) {
            setTimeout(this.showNext(),2000)
            this.rightNum++;
            if(this.rightNum==10){
                this.modalshow = true;
            }          
            this.widthStyle.width = (this.rightNum*(100/10))+'%';
            let length = this.rightNum*(100/10)
            if(length>=100){
              this.widthStyle.width = '100%'
            }
          }else{
            this.next = true
          }
        }
        else {
          this.saveCosKnowlegeAnswer()
        }
      },
      continueNext(){
        this.showNext()
        this.next = false
      },
      continueBack(){
        this.modalshow = false;
      },
      showNext(){
        this.arr.map((item)=>{
          // 判断答案正确，显示下一题
          if(item.show){
            item.show=false
          }
          if (item.num == (this.current + 1)) {
            item.show=true
            return true
          }
          if(this.current>=60){
           this.show= true
          }
        })
      },
      continueBack(){ 
        this.modalshow = false;
      }   
  }
}
</script>
<style>

</style>
